(function () {
  const LOG = '[DirectCheckout]';

  // 1) Patch the theme’s cart error handler so it never kicks to /cart
  function patchCartError() {
    try {
      const CI = window.CartItems && window.CartItems.prototype;
      if (!CI || typeof CI.onCartError !== 'function' || CI.onCartError.__patched) return;

      const orig = CI.onCartError;
      CI.onCartError = function (errors, target) {
        if (target) {
          try { this.disableLoading?.(target.getAttribute('data-index')); this.setValidity?.(target, errors); } catch (_) {}
          return;
        }
        // Show the error in the drawer instead of redirecting
        const msg = Array.isArray(errors) ? errors.join('\n')
          : (errors && typeof errors === 'object' ? Object.values(errors).join('\n') : String(errors || 'Cart error'));

        console.warn(LOG, 'Cart error shown in drawer (no redirect):', msg);
        const mini = document.querySelector('[id^="MiniCart-"]') || document.getElementById('CartDrawer');
        if (mini) {
          const el = document.createElement('div');
          el.className = 'alert alert--error text-sm leading-tight';
          el.style.marginBottom = '8px';
          el.textContent = msg;
          mini.prepend(el);
        } else {
          alert(msg);
        }
      };
      CI.onCartError.__patched = true;
      console.info(LOG, 'Patched CartItems.onCartError');
    } catch (_) {}
  }

  // 2) Do a POST /cart then go to /checkout (keeps apps that need a POST happy)
  async function goDirectToCheckout() {
    try {
      const fd = new FormData(); fd.append('checkout', '1');
      await fetch('/cart', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'text/html,application/xhtml+xml' } });
    } catch (e) {
      console.warn(LOG, 'POST /cart failed, continuing to checkout', e);
    }
    window.location.assign('/checkout');
  }

  // 3) Attach capture-phase handler on the drawer footer form
  function attach(root = document) {
    const form = root.querySelector('form.drawer__footer-buttons');
    if (!form || form.__dc_patched) return;

    // Strip previously bound submit handlers on this node (apps/themes)
    const clean = form.cloneNode(true);
    form.parentNode.replaceChild(clean, form);

    // Capture-phase submit wins over most other listeners
    clean.addEventListener('submit', (e) => {
      const submitter = e.submitter || document.activeElement;
      if (submitter && submitter.getAttribute('name') === 'checkout') {
        e.preventDefault();
        e.stopImmediatePropagation();
        goDirectToCheckout();
      }
    }, true);

    // Also guard the button click itself
    const btn = clean.querySelector('button[name="checkout"]');
    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        goDirectToCheckout();
      }, true);
    }

    clean.__dc_patched = true;
    console.info(LOG, 'Checkout override attached');
  }

  // 4) Re-apply after updates / drawer re-render
  function install() {
    patchCartError();
    attach();

    document.addEventListener('cart:updated', () => attach(), { passive: true });
    document.addEventListener('cart:refresh', () => attach(), { passive: true });

    const drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(() => attach(drawer)).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(install, 0);
  } else {
    document.addEventListener('DOMContentLoaded', install);
  }
})();
